import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon_48.png'


const _withScopeId = n => (_pushScopeId("data-v-48150869"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-100 flex-column" }
const _hoisted_2 = {
  style: {"overflow-y":"scroll"},
  "infinite-scroll-immediate": false
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "flex-row-center-sb" }
const _hoisted_5 = { class: "fz-14 co-1F2533 one-row flex-1" }
const _hoisted_6 = { class: "flex-row-center-start" }
const _hoisted_7 = {
  key: 0,
  class: "point mr-4"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fz-12 co-949CA9" }, "立即处理", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "wh-10 ml-5",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_10 = { class: "fz-12 co-949CA9 mt-6" }

import { ref, getCurrentInstance } from 'vue';
	import config from '@/api/config';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'ReminderPop',
  setup(__props, { expose: __expose }) {

	const { proxy } = getCurrentInstance() as any;
	const pop = ref(false);
	const total = ref<any>(0);
	const list = ref<any>([]);
	const page = ref(1);
	const size = ref(config.PagesSize[0]);
	const loading = ref<any>(false);
	const boxRef = ref<any>();
	const boxHeight = ref<any>(0);

	const open = () => {
		pop.value = true;
		RefreshList({
			page: 0,
		});
	};
	const close = () => {
		pop.value = false;
	};
	const ClickOrderStatusItem = (data : any) => {
		proxy.$api.tokenRequest({
			url: '/admin/notice/reads',
			isLoading: '加载中...',
			method: "POST",
			data: {
				id: data.id,
			},
			success: () => {
				RefreshList({
					page: 1,
				});
			}
		});
		if (data.target_url == "type=1") {
			return false;
		}
		if (data.type == 2) {
			proxy.$router.replace({
				path: "/GoodManage/InventoryAlert",
			});
		} else {
			proxy.$router.replace({
				path: "/ReportManager/NotificationRecord",
			});
		}
		close();
	};
	const GetList = () => {
		if (loading.value) return false
		loading.value = true;
		let pages = page.value;
		pages++;
		proxy.$api.tokenRequest({
			url: '/admin/notice/system',
			isLoading: '加载中...',
			data: {
				page: pages,
				size: size.value,
			},
			success: (res : any) => {
				loading.value = false;
				list.value = list.value.concat(res.data.data);
				total.value = res.data.total;
				if (res.data.data.length > 0) {
					page.value = pages;
				}
			},
			fail: () => {
				loading.value = false;
			}
		});
	};
	const RefreshList = (data : any) => {
		list.value = [];
		page.value = data.page;
		GetList();
	};

	__expose({
		open,
		close,
	})

return (_ctx: any,_cache: any) => {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: pop.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pop).value = $event)),
    title: "",
    "modal-class": "mode-class",
    "with-header": false,
    direction: "rtl",
    size: "25%"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_PageTitle, { name: "待办事项" }),
        _withDirectives((_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (v, i) => {
            return (_openBlock(), _createElementBlock("li", { key: i }, [
              _createElementVNode("div", {
                class: "ptb-12 boderb1-EBEBED pointer",
                onClick: ($event: any) => (ClickOrderStatusItem(v))
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(v.content), 1),
                  _createElementVNode("div", _hoisted_6, [
                    (v.is_read == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                      : _createCommentVNode("", true),
                    _hoisted_8,
                    _hoisted_9
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(v.create_time), 1)
              ], 8, _hoisted_3)
            ]))
          }), 128))
        ])), [
          [_directive_infinite_scroll, GetList]
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})